import { Component, OnInit, AfterViewInit, ViewEncapsulation, HostListener, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { GridOptionsModel, ColumnDefinitionsModel } from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { ManageInventoryService } from '../../manage-inventory/shared/providers/manage-inventory.service';
import { StepIndicatorModel, StepIndicatorService } from 'lib/ng2-sapmp/src/ui-components';
import { SignupSetupInputModel, SignupSetupOutputModel, FanModel, EnrollmentDateModel } from '../../signup-setup/shared/models/signup-setup.models';
// import { AccordionComponent } from 'lib/ng2-sapmp/src/ui-components/accordion/accordion.component';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { SIGNUPSETUPDATA } from 'config';
import { BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb/breadcrumb.service';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot';
import { MOBILEPIVOTS, TERMSCONDITIONS } from 'config';
import { ConfirmModalPopupModel } from 'lib/ng2-sapmp/src/ui-components/confirm-modal';
import { SignupSetupService } from '../shared/providers/signup-setup.service';
import { KEY_CONFIG } from 'lib/ng2-sapmp/src/config/key-config';



@Component({
  selector: 'app-enrollmentpoc',
  templateUrl: './enrollmentpoc.component.html',
  styleUrls: ['./enrollmentpoc.component.scss'],
  providers: [SignupSetupService, ManageInventoryService, AdobeAnalyticsService],
  encapsulation: ViewEncapsulation.None
})

export class EnrollmentpocComponent implements OnInit {

  @ViewChild('fileInput') fileInput: ElementRef;
  gridOptions: Array<GridOptionsModel>;
  stepIndicators: StepIndicatorModel[];
  confirmModalPopup: ConfirmModalPopupModel;
  stepSessionName: string;
  initModal: boolean;
  modalMsg: string;
  mailId: string;
  videoId: string;
  modalClass: string;
  signupSetup: boolean = false;
  backFromReview: boolean = false;
  signupSetupInputData: SignupSetupInputModel;
  signupSetupOutputData: SignupSetupOutputModel;
  companyId: number;
  haveTab: boolean;
  activeTab: number;
  selectedFanList: number;
  tabArray: Array<any>;
  accordionList: boolean;
  pageTitle: string;
  pageDescription: string;
  pageLink: string;
  pageDescription2: string;
  accountsData: any;
  showError: boolean;
  errorMessage: string;
  showGoogleCreationError: boolean;
  dcmCodes = 'ABC_TNC_001';
  haveAccordion: boolean;
  eligibleFanCount: number;
  pivots: Array<MobilePivotModel>;
  termscondUrl: any;
  termsCondproductURl: any;
  selected: any;
  eventEmit: any;
  title: any;
  supportArticle: any;
  showOverviewModal: boolean;
  private enrollDates: EnrollmentDateModel;
  private FANListSel: Array<FanModel> = [];
  private FANListAdd: Array<FanModel> = [];
  private FANListAct: Array<FanModel> = [];
  private FANListPro: Array<FanModel> = [];
  private FANListALL: Array<FanModel> = [];
  private successfullySignupFAN: Array<FanModel> = [];
  selectedFansCount: Array<number> = [];
  helpArticles: any;
  article: any;
  isMobile: any;
  termsCondi: any;
  staticTcUrl: any;
  guideUrl: any;
  MdmSelection: any;
  prodFlag: boolean;
  emmProductCode: any;
  tmc: any;
  kme: boolean;
  ztp: boolean;
  abm: boolean;
  mdm: boolean;
  querytab: string;
  supportArticles: any;
  prodcode: string;
  emailEnabled: boolean = true;
  smsEnabled: boolean = true;
  notificationType: any = '';
  @ViewChild('emailNotification') emailNotification: ElementRef;
  @ViewChild('textMessageNotification') textMessageNotification: ElementRef;
  @ViewChild('enrollBox') enrollBox: ElementRef;
  initialSignup: boolean = false;
  readySignupSetupFans: any[];
  isFansZero: boolean = false;
  enableCont: boolean = false;
  signupData: any;
  notfFlag : boolean = false;
  canEnroll: boolean = false;
  enrollArray: any[] = [];
  showErrors: boolean = false;
  enrollEnable: boolean = false;
  allFansData: any;
  signupDataBack: any;
  checkedFanList: any;
  failFromReviewFlag: string;
  constructor(private router: Router,
    private pageloaderService: PageLoaderService,
    private activatedRoute: ActivatedRoute,
    private signupSetupService: SignupSetupService,
    private manageInventoryService: ManageInventoryService,
    private utilityService: UtilityService,
    private stepindicatorService: StepIndicatorService,
    private adobeAnalyticsService: AdobeAnalyticsService,
    private breadCrumbService: BreadCrumbService,
    private pageLoaderService: PageLoaderService,private stepIndicatorService: StepIndicatorService,private route: ActivatedRoute) {

      this.gridOptions = [];
      this.eligibleFanCount =0;
      this.enrollArray =[];
     }

  ngOnInit() {

    this.breadCrumbService.removeLastBreadCrumb();
    this.breadCrumbService.setCurrentBreadCrumb({ label: 'Device Enrollment Program', routerLink: '/signupsetup/enrollmentoptions' });

    this.stepIndicatorService.setCurrentStep("enrollmentoptions");
    this.stepIndicatorService.setVisibility(true);

    const arrTemp = [
      {
          "fanId": "57503613",
          "addpEligibleStatus": true
      },
      {
          "fanId": "57503609",
          "addpEligibleStatus": true
      },
      {
          "fanId": "57503614",
          "addpEligibleStatus": true
      }
  ]

  const configArr = [
    {
        "caption": "Foundation account",
        "field": "fanId",
        "type": "TEXT",
        "sortDirection": "Asc",
        "enableSorting": false,
        "enableFilter": false,
        "cssClass": "",
        "priority": 1,
        "customTemplate": "fanEligiblityStatus"
    },
    {
        "caption": "Existing devices",
        "field": "enroll",
        "type": "CUSTOMCONTENT",
        "sortDirection": "Asc",
        "enableSorting": false,
        "enableFilter": false,
        "cssClass": "",
        "priority": 2,
        "templateIndex": 0
    }
]

const rowArr = {
  "field": "addpEligibleStatus"
}

    this.initGrid(arrTemp,configArr,false,'','');
  }


  initGrid(respobj, colDef: Array<ColumnDefinitionsModel>, disableRow: boolean, disableRowCondition,
    disableRowConditionInverse) {
    const options = new GridOptionsModel();
    options.enableFiltering = false;
    options.enableSorting = false;
    options.multiSelect = true;
    options.disableSelectAll = true;
  
    

    const mdmDetails = JSON.parse(sessionStorage.getItem('mdmDetails'));
    
    const pagination = {
      recordsPerPage: 20,
      currentPage: 1,
      isServerSide: false,
      totalRecords: respobj.length
    };

    options.Paginations = pagination;
  
    

    
    options.gridData = respobj;
    options.columnDefinitions = colDef;
    options.gridData = options.gridData.map(data => {
      if(data.enroll === undefined) {
        data.enroll = false;
      }
      return data;
    });
    //options.searchPlaceHolder = 'Enter full foundation account number';
    //options.searchType = 'number';
    this.gridOptions.push(options);
    
  }

  continueToNext(){

    this.router.navigate(['/signupsetup/reviewpoc']);


  }

  existingDevices(row) {

    const fromBackFlag = JSON.parse(sessionStorage.getItem('step1done'));
    let updateSelectedSignupFanList = JSON.parse(sessionStorage.getItem('selectedSignupFanList'));
    if (fromBackFlag || this.failFromReviewFlag) {
      this.enrollArray = JSON.parse(sessionStorage.getItem('enrollArray'));
      if (this.enrollArray !== null) {
        if (this.enrollArray.includes(row.fanId) !== true) {
          if (row.enroll !== row.selected) {
            this.enrollArray.push(row.fanId);
          }
        } else {
          //this.enrollArray.remove(row.fanId);
          const index = this.enrollArray.indexOf(row.fanId);
          if (index > -1) {
            this.enrollArray.splice(index, 1);
          }
          console.log(this.enrollArray);
        }
      } else {
        this.enrollArray = [];
        row.enroll = true;
        this.enrollArray.push(row.fanId);
      }
      sessionStorage.setItem('enrollArray', JSON.stringify(this.enrollArray));
      updateSelectedSignupFanList.forEach(element => {
        if (element.fanId === row.fanId) {
          element.enroll = row.selected;
        }
      });
      sessionStorage.setItem('selectedSignupFanList', JSON.stringify(updateSelectedSignupFanList));
      sessionStorage.removeItem('step1done');
    } else {
      //this.enrollArray.push(row.fanId);
      if (this.enrollArray.includes(row.fanId) === false) {
        this.enrollArray.push(row.fanId);
      }
      sessionStorage.setItem('enrollArray', JSON.stringify(this.enrollArray));
      sessionStorage.removeItem('step1done');
    }
    //console.log(this.enrollArray);
    
  }

  onRowClick(action) {

    if (action !== "") {
      if(action.data.selected === true){
        this.eligibleFanCount++;
        this.enrollArray.push(action.data.fanId)
        sessionStorage.setItem("enrollArraypoc", JSON.stringify(this.enrollArray));


      }
    }







  }



}
